export default function fixedHeader() {
	const header = document.querySelector('header');
	const logo = document.querySelector('.custom-logo');
	let scrollObject = {};
	let originalSrc = '';

	if (!header) {
		return false;
	}

	// Store original src on page load
	if (logo) {
		originalSrc = logo.src;
	}

	function setOriginalLogo() {
		if( originalSrc && logo.src !== originalSrc ) {
			logo.src = originalSrc;
		}
	}

	function setOverlayLogo() {
		if (window.innerWidth > 992 && logo && logo.dataset.overlaySrc) {
			logo.src = logo.dataset.overlaySrc;
		}
	}

	function getScrollPosition() {
		scrollObject = {
			x: window.pageXOffset,
			y: window.pageYOffset,
		};
		if (scrollObject.y > 0.1) {
			header.classList.add('header--scroll');
			setOriginalLogo()
		} else {
			header.classList.remove('header--scroll');
			setOverlayLogo();
		}
	}

	getScrollPosition();

	// if (window.innerWidth < 992 && logo && logo.dataset.originalSrc) {
	// 	changeLogo();
	// }

	window.addEventListener('scroll', getScrollPosition);
}